<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M537.4 131.1C544.5 136.3 546.1 146.3 540.9 153.5L260.9 537.5C258.1 541.3 253.9 543.7 249.2 544C244.5 544.3 240 542.7 236.6 539.4L100.6 403.4C94.4 397.2 94.4 387 100.6 380.8C106.8 374.6 117 374.6 123.2 380.8L246 503.6L515 134.7C520.2 127.6 530.2 126 537.4 131.2z"
      fill="currentColor"
    />
  </svg>
</template>
